import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminLandmarkDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import NewLandmarkModal from 'components/pages/landmark/NewLandmarkModal';
import LandmarkCard from 'components/pages/landmark/LandmarkCard';

const LandmarkSettingPage = () => {
  const { uiStore } = useStoreWrapper();

  const [landmarks, setLandmarks] = useState<AdminLandmarkDto[]>([]);

  const handleAddLandmark = (landmark?: AdminLandmarkDto) => {
    uiStore?.modal.show({
      title: '가볼만한곳 추가',
      style: { width: 1200, height: '100%', maxHeight: '90%' },
      children: <NewLandmarkModal landmark={landmark} />,
      onConfirmed: () => {
        fetchService();
      },
    });
  };

  const handleClickLandmark = (landmark: AdminLandmarkDto) => {
    handleAddLandmark(landmark);
  };

  const fetchService = () => {
    ServiceHelper?.adminLandmarkService?.getLandmarks().then((res) => {
      setLandmarks(res.data);
    });
  };

  useEffect(() => {
    fetchService();
  }, []);

  return (
    <PageLayout
      title="가볼만한곳 설정"
      actionButton={<NewButton onClick={handleAddLandmark}>장소추가</NewButton>}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        {landmarks.map((landmark) => (
          <div key={landmark.id}>
            <LandmarkCard
              landmark={landmark}
              onClick={() => {
                handleClickLandmark(landmark);
              }}
            />
          </div>
        ))}
      </div>
    </PageLayout>
  );
};

export default LandmarkSettingPage;
